import ModalViewUser from "./modal-view-user";

export default ModalViewUser;